import { useCallback } from "react";
import { useNavigate, useParams, useSearch } from "@tanstack/react-router";
import { DisplayScreen, StatusIndicator } from "@/screens/display-screen";

export { StatusIndicator };

export function DisplayPage() {
  const navigate = useNavigate();
  const { slug } = useParams({ from: "/display/$slug" });
  const { auth: authToken, debugShell } = useSearch({ from: "/display/$slug" });

  const handleNavigateToBoardSetup = useCallback((targetSlug: string) => {
    navigate({ to: "/boards/$slug", params: { slug: targetSlug } });
  }, [navigate]);

  const handleNavigateToDashboard = useCallback(() => {
    navigate({ to: "/dashboard" });
  }, [navigate]);

  return (
    <DisplayScreen
      slug={slug}
      authToken={authToken}
      debugShell={debugShell}
      onNavigateToBoardSetup={handleNavigateToBoardSetup}
      onNavigateToDashboard={handleNavigateToDashboard}
    />
  );
}
